import React from 'react'
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footers from '../../Footers';
import './Shilajit.css';
import Benefit from '../services-images/benefit.webp';
import NewsletterSection from '../../NewsletterSection';
import product1 from "../../assets/images/l1.webp";
import product2 from "../../assets/images/l5.webp";
import product3 from "../../assets/images/l6.jpg";
import product4 from "../../assets/images/l7.webp";
import product5 from "../../assets/images/l8.jpg";
import product6 from "../../assets/images/l9.webp";
import product7 from "../../assets/images/l10.webp";
import product8 from "../../assets/images/l11.webp";
import product9 from "../../assets/images/l12.webp";
import product10 from "../../assets/images/l13.webp";
import LatestTestimonials from '../../LatestTestimonials';
import { useCart } from '../../cart/CartContext';
import { useNavigate } from 'react-router-dom';
const defaultImages = [product1, product2, product3, product4, product5, product6, product7, product8, product9, product10];
const products = [
  {
    id: 1,
    category: "Nutrabay Shudh Himalayan Shilajit/shilajeet Resin From",
    price: 1349.00,
    oldPrice: 2800.00,
    rating: 4,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 2,
    category: "Kapiva Shilajit Gold Resin",
    price: 549.00,
    oldPrice: 999.00,
    rating: 3,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 3,
    category: "Vlado's Himalayan Organics Shilajit Gold Resin",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 4,
    category: "Kapiva Himalayan Shilajit Resin",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
  {
    id: 5,
    category: "UMuscleblaze Koshaveda Shilajit Pro",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
  {
    id: 6,
    category: "Neuherbs Pure & Original Himalayan Shilajit / Shilajeet",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
  {
    id: 7,
    category: "Dr. Morepen Shilajit Capsules For Strength, Stamina & Vigor",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
  {
    id: 8,
    category: "Upakarma Ayurveda Pure Shilajit",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
  {
    id: 9,
    category: "Neuherbs Shilajit Gold Ultra",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
  {
    id: 10,
    category: "Vlado's Himalayan Organics Shilajit Gold Resin",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",

  },
];

const StarRating = ({ rating }) => (
  <div className="star-rating">
    {Array(5).fill(0).map((_, i) => (
      <span key={i} className={i < rating ? "filled" : "empty"}>★</span>
    ))}
  </div>
);

export default function Shilajit() {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleBuyNow = (product) => {
    addToCart(product);
    navigate('/cart');
  };

  return (
    <div>
      <Header />
      <Navbar />
      <section className="deal-section">
        <div className="deal-header">
          <div>
            <h2 className="deal-title">
              <span className="highlight">Shilajit</span>
            </h2>
            <p className="deal-subtitle">Showing 1 - 10 of 10 Products</p>
          </div>
        </div>

        <div className="product-grid">
          {products.map((product, idx) => {
            const imageSrc = defaultImages[idx % defaultImages.length];
            return (
              <div key={idx} className="product-card">
                <div className="product-image-wrapper">
                  <img src={imageSrc} alt={product.title || "Product"} className="product-image" />
                </div>
                <div className="product-info">
                  <p className="category">{product.category}</p>
                  <StarRating rating={product.rating} />
                  <div className="price-row">
                    <span className="price">₹{product.price.toFixed(2)}</span>
                    <span className="old-price">₹{product.oldPrice.toFixed(2)}</span>
                  </div>
                  <h3 className="BiParagraph">{product.BiParagraph}</h3>
                  <button className="add-to-cart-btn" onClick={() => handleBuyNow(product)}>ADD TO CART</button>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <div className="top-benefits-container">
        <div className="benefits-text">
          <h2>Health Benefits of Shilajit</h2>
          <ul>
            <li>✅ Beneficial for a multitude of medical conditions</li>
            <li>✅ Helps in the regeneration of Cells and Tissues in the body</li>
            <li>✅ Helps improve the texture of skin</li>
            <li>✅ Strengthen the heart muscles and purify the blood</li>
            <li>✅ Enhances physical endurance</li>
          </ul>
        </div>

        <div className="benefits-image">
          <img src={Benefit} alt="icons" className="Banner" />
        </div>
      </div>

      <section className="how-to-use-section">
        <h2 className="section-title">How to Use Shilajit?</h2>
        <div className="steps-container">
          <div className="step">
            <h3>STEP 1 : Dosage Instructions</h3>
            <p>Take a dose of up to 500 mg once daily, or a pea- or rice-sized chunk.</p>
          </div>
          <div className="step">
            <h3>STEP 2 : How to Mix & Consume</h3>
            <p>It can be consumed with warm milk or water throughout the year.</p>
          </div>
          <div className="step">
            <h3>STEP 3 : Best Time to Take Shilajit</h3>
            <p>Consume daily early morning on an empty stomach.</p>
          </div>
        </div>
      </section>

      <LatestTestimonials />
      <NewsletterSection />
      <Footers />
    </div>
  );
}









